import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import InventoryCount from "./InventoryCount/index";
import Stock from "./StockControl/index";
import Fulfillments from "./Fulfillments/index";

const inventoryParent = ({ match }) => (
  <Switch>
    <Route
      path={`${match.url}/inventoryCount`}
      render={(props) => <InventoryCount {...props} />}
    />
    <Route
      path={`${match.url}/stockControl`}
      render={(props) => <Stock {...props} />}
    />
    <Route
      path={`${match.url}/fulfillment`}
      render={(props) => <Fulfillments {...props} />}
    />
  </Switch>
);

export default inventoryParent;
